import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import EngineerLayout from './EngineerLayout';
import { 
    FaArrowLeft, 
    FaSearch,
    FaCopy,
    FaFileExcel,
    FaPrint,
    FaSort
} from 'react-icons/fa';

const EngineerSocietyWorksDistributionList = () => {
    const navigate = useNavigate();
    const [taluka, setTaluka] = useState('तालुका निवडा');
    const [year, setYear] = useState('२०२६');
    const [searchTerm, setSearchTerm] = useState('');

    // Sample data from the image
    const [data] = useState([
        { id: "१", name: "छ.यशवंत मजूर को-ऑप सोसायटी", phone: "९५७७५९३५३५", taluka: "हवेली", count: "४", amount: "२३४४०००", licenseDate: "४ जुलै २०२६", joinDate: "२०२५" },
        { id: "२", name: "जय नवनाथ भटके विमुक्त जाती जमाती को ऑप सोसायटी लि", phone: "८७९३५३९००७", taluka: "दौंड", count: "६", amount: "४८०७०२५", licenseDate: "१३ फेब्रुवारी २०२७", joinDate: "२०२५" },
        { id: "३", name: "कानिफनाथ मजूर को-ऑप सोसायटी लिमिटेड", phone: "९५३०१६१६८८", taluka: "हवेली", count: "३", amount: "२५०००००", licenseDate: "४ जुलै २०२६", joinDate: "२०२५" },
        { id: "४", name: "जगदंबा मजूर को ऑप सोसायटी लि", phone: "९०२११०५१८१", taluka: "शिरूर", count: "५", amount: "३१५००००", licenseDate: "२२ डिसेंबर २०२६", joinDate: "२०२५" },
        { id: "५", name: "छ मच्छिंद्रनाथ एमएस संस्था लि", phone: "७०५७२९५०५७", taluka: "शिरूर", count: "७", amount: "५८६१०००", licenseDate: "२८ नोव्हेंबर २०२४", joinDate: "२०२५" },
        { id: "६", name: "छ. शिवशंभू एमएस संस्था लि.", phone: "९५४५००५०५७", taluka: "पुरंदर", count: "६", amount: "४५०००००००", licenseDate: "२८ नोव्हेंबर २०२४", joinDate: "२०२५" },
    ]);

    return (
        <EngineerLayout>
            <div className="p-8 bg-[#f4f7fe] min-h-screen font-hind text-left">
                {/* Header Section */}
                <div className="flex justify-between items-center mb-10 px-2 text-left">
                    <div className="flex items-center gap-6">
                        <button 
                            onClick={() => navigate('/engineer/total-work-distribution-menu')}
                            className="p-4 bg-white rounded-2xl shadow-sm hover:bg-gray-50 transition-all text-gray-600 border border-gray-100 hover:scale-105 active:scale-95 group"
                        >
                            <FaArrowLeft size={18} className="group-hover:-translate-x-1 transition-transform" />
                        </button>
                        <h1 className="text-2xl font-black text-gray-800 tracking-tight">सोसायटी वर्क्स वितरण यादी</h1>
                    </div>
                    <div className="hidden md:flex items-center gap-3 text-[11px] font-black text-gray-400 bg-white px-6 py-3 rounded-2xl border border-gray-100 shadow-sm uppercase tracking-wider">
                        जिल्हा परिषद / <span className="text-purple-600">सोसायटी वर्क्स वितरण यादी</span>
                    </div>
                </div>

                {/* Main Content Card */}
                <div className="bg-white rounded-lg shadow-sm border border-gray-100 p-8">
                    {/* Filters Section */}
                    <div className="flex flex-wrap gap-8 items-end mb-10">
                        <div className="space-y-2 text-left flex-1 min-w-[200px] max-w-sm">
                            <label className="text-[14px] font-black text-gray-500 tracking-tight">तालुका निवडा</label>
                            <select 
                                className="w-full border border-gray-100 rounded-lg px-4 py-3 outline-none focus:border-purple-500 bg-gray-50/50 text-gray-700 font-bold transition-all appearance-none"
                                value={taluka}
                                onChange={(e) => setTaluka(e.target.value)}
                            >
                                <option value="तालुका निवडा">तालुका निवडा</option>
                                <option value="हवेली">हवेली</option>
                                <option value="दौंड">दौंड</option>
                                <option value="शिरूर">शिरूर</option>
                                <option value="पुरंदर">पुरंदर</option>
                            </select>
                        </div>
                        <div className="space-y-2 text-left flex-1 min-w-[200px] max-w-sm">
                            <label className="text-[14px] font-black text-gray-500 tracking-tight">वर्ष निवडा</label>
                            <select 
                                className="w-full border border-gray-100 rounded-lg px-4 py-3 outline-none focus:border-purple-500 bg-gray-50/50 text-gray-700 font-bold transition-all appearance-none"
                                value={year}
                                onChange={(e) => setYear(e.target.value)}
                            >
                                <option value="२०२६">२०२६</option>
                                <option value="२०२५">२०२५</option>
                            </select>
                        </div>
                        <div>
                            <button className="bg-[#6366f1] hover:bg-[#4f46e5] text-white px-10 py-3 rounded-lg font-bold shadow-lg shadow-indigo-500/20 transition transform active:scale-95 flex items-center gap-2 uppercase tracking-wide">
                                शोध
                            </button>
                        </div>
                    </div>

                    {/* Action Buttons & Utilities */}
                    <div className="flex flex-col md:flex-row justify-between items-center gap-6 mb-8 border-t border-gray-50 pt-8">
                        <div className="flex gap-2">
                            <button className="flex items-center gap-2 px-5 py-2.5 bg-[#6b7280] hover:bg-[#4b5563] text-white text-sm font-bold rounded shadow-sm transition-all group">
                                <FaCopy size={14} className="group-hover:scale-110 transition-transform" /> कॉपी करा
                            </button>
                            <button className="flex items-center gap-2 px-5 py-2.5 bg-[#6b7280] hover:bg-[#4b5563] text-white text-sm font-bold rounded shadow-sm transition-all group">
                                <FaFileExcel size={14} className="group-hover:scale-110 transition-transform" /> एक्सेल
                            </button>
                            <button className="flex items-center gap-2 px-5 py-2.5 bg-[#6b7280] hover:bg-[#4b5563] text-white text-sm font-bold rounded shadow-sm transition-all group">
                                <FaPrint size={14} className="group-hover:scale-110 transition-transform" /> प्रिंट
                            </button>
                        </div>
                        <div className="flex items-center gap-4">
                            <label className="text-sm font-bold text-gray-500">शोध:</label>
                            <div className="relative">
                                <input 
                                    type="text" 
                                    className="border border-gray-200 rounded px-4 py-2 w-64 outline-none focus:border-purple-500 focus:ring-1 focus:ring-purple-200 text-sm font-bold transition-all"
                                    value={searchTerm}
                                    onChange={(e) => setSearchTerm(e.target.value)}
                                />
                            </div>
                        </div>
                    </div>

                    {/* Table Section */}
                    <div className="overflow-x-auto border border-gray-100 rounded-lg shadow-sm">
                        <table className="w-full border-collapse">
                            <thead>
                                <tr className="bg-white border-b border-gray-200 text-[13px] font-black text-gray-800 text-left">
                                    <th className="px-5 py-5 border-r border-gray-100 min-w-[50px]"><div className="flex items-center justify-between"># <FaSort className="text-gray-300 ml-2" size={10} /></div></th>
                                    <th className="px-5 py-5 border-r border-gray-100 min-w-[250px]"><div className="flex items-center justify-between">संस्थेचे नाव <FaSort className="text-gray-300 ml-2" size={10} /></div></th>
                                    <th className="px-5 py-5 border-r border-gray-100 min-w-[150px]"><div className="flex items-center justify-between">फोन नंबर. <FaSort className="text-gray-300 ml-2" size={10} /></div></th>
                                    <th className="px-5 py-5 border-r border-gray-100 min-w-[120px]"><div className="flex items-center justify-between">तालुका <FaSort className="text-gray-300 ml-2" size={10} /></div></th>
                                    <th className="px-5 py-5 border-r border-gray-100 min-w-[150px]"><div className="flex items-center justify-between">कामांची संख्या <FaSort className="text-gray-300 ml-2" size={10} /></div></th>
                                    <th className="px-5 py-5 border-r border-gray-100 min-w-[150px]"><div className="flex items-center justify-between">कामाची रक्कम <FaSort className="text-gray-300 ml-2" size={10} /></div></th>
                                    <th className="px-5 py-5 border-r border-gray-100 min-w-[150px]"><div className="flex items-center justify-between">परवाना तारीख <FaSort className="text-gray-300 ml-2" size={10} /></div></th>
                                    <th className="px-5 py-5 min-w-[120px]"><div className="flex items-center justify-between">तारीख जोडा <FaSort className="text-gray-300 ml-2" size={10} /></div></th>
                                </tr>
                            </thead>
                            <tbody>
                                {data.map((item, index) => (
                                    <tr key={index} className="hover:bg-blue-50/10 transition-colors border-b border-gray-100 last:border-0 text-[14px] text-gray-700 font-bold text-left">
                                        <td className="px-5 py-5 border-r border-gray-100">{item.id}</td>
                                        <td className="px-5 py-5 border-r border-gray-100 leading-relaxed">{item.name}</td>
                                        <td className="px-5 py-5 border-r border-gray-100 text-[#1e293b]">{item.phone}</td>
                                        <td className="px-5 py-5 border-r border-gray-100">{item.taluka}</td>
                                        <td className="px-5 py-5 border-r border-gray-100">
                                            <div className="flex items-center gap-2">
                                                {item.count} - <button className="text-blue-600 hover:text-blue-800 hover:underline transition-colors">कामाचे तपशील</button>
                                            </div>
                                        </td>
                                        <td className="px-5 py-5 border-r border-gray-100">{item.amount || "-"}</td>
                                        <td className="px-5 py-5 border-r border-gray-100">{item.licenseDate}</td>
                                        <td className="px-5 py-5">{item.joinDate}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>

            <style>{`
                @import url('https://fonts.googleapis.com/css2?family=Hind:wght@400;500;600;700&display=swap');
                .font-hind {
                    font-family: 'Hind', sans-serif;
                }
            `}</style>
        </EngineerLayout>
    );
};

export default EngineerSocietyWorksDistributionList;
